import { render, staticRenderFns } from "./OINPay.vue?vue&type=template&id=3c5b63af&scoped=true&"
import script from "./OINPay.vue?vue&type=script&lang=js&"
export * from "./OINPay.vue?vue&type=script&lang=js&"
import style0 from "../../less/oinPay.less?vue&type=style&index=0&id=3c5b63af&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5b63af",
  null
  
)

export default component.exports